module.exports = __webpack_public_path__ + "img/footer-buy.b2c4e407.png";